var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteIcon = function SvgQuoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 4.288V7.13c0 2.117 0 3.175.652 3.833.65.657 1.698.657 3.793.657h1.112c2.094 0 3.142 0 3.793-.657.65-.658.65-1.716.65-3.833V4.288m-10 0h10m-10 0 .481-1.026c.374-.796.56-1.193.938-1.417s.862-.224 1.832-.224h3.5c.969 0 1.454 0 1.832.224s.564.621.937 1.417L13 4.288m-6 2h2m-1 7v1.666m0-1.666H4.668m3.334 0h3.333m-6.667 0H3.001a1.667 1.667 0 0 0-1.667 1.666m3.333-1.666v1.666m6.667-1.666h1.667a1.667 1.667 0 0 1 1.666 1.666m-3.333-1.666v1.666"
  })));
};
export default SvgQuoteIcon;